'use client';

import { useState } from 'react';
import { toast } from 'sonner';
import { Mail } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { subscribeToNewsletter } from '../../firebase/blog-db';
import { sendEmail } from '../../lib/email';

export function NewsletterSignupForm() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    const trimmed = email.trim();
    try {
      await subscribeToNewsletter(trimmed);
      setDone(true);
      toast.success("You're on the list!");
      sendEmail({
        to_email: trimmed,
        subject: "You're subscribed to Hustlance Blog!",
        message: "Thanks for subscribing to Hustlance Blog. You'll get an email whenever we publish a new story.",
      }).catch(() => {});
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-hustlance-primary to-hustlance-secondary rounded-2xl p-8 sm:p-10 text-center text-white">
      <Mail className="w-10 h-10 mx-auto mb-4 opacity-90" />
      <h3 className="text-2xl font-bold mb-2">Never miss a story</h3>
      <p className="text-white/90 mb-6 max-w-md mx-auto">
        Get the latest freelancing guides, student stories, and Hustlance updates in your inbox.
      </p>
      {done ? (
        <p className="font-semibold">Thanks for signing up — you're on the list.</p>
      ) : (
        <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
          <Input
            type="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="you@university.edu"
            aria-label="Email address"
            className="bg-white text-gray-900 border-transparent"
          />
          <Button type="submit" disabled={submitting} variant="secondary" className="whitespace-nowrap">
            {submitting ? 'Signing up...' : 'Subscribe'}
          </Button>
        </form>
      )}
    </div>
  );
}
